/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_LocatingInputs */

const en_directory_search_locating = /** @type {(inputs: Directory_Search_LocatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finding you…`)
};

const pl_directory_search_locating = /** @type {(inputs: Directory_Search_LocatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustalam, gdzie jesteś…`)
};

/**
* | output |
* | --- |
* | "Finding you…" |
*
* @param {Directory_Search_LocatingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_locating = /** @type {((inputs?: Directory_Search_LocatingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_LocatingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_locating(inputs)
	return en_directory_search_locating(inputs)
});